module.exports = __webpack_public_path__ + "img/burger-collapse-icon.81c334e6.svg";